module.exports = __webpack_public_path__ + "img/ring_y_c_0_0@3x.7ea525b2.png";